/**
 * 缓存说明:资源文件包括图片等
 */
import vm from './storeTools.js'
import resourcesApi from '@/components/api/resourcesApi.js'

var basestate = {
	//皮肤名称对应皮肤对象，在外部注入
	skinNameToSkinObject: {},
	//当前皮肤对象
	nowSkinObject: undefined,
	pathList: undefined,
	//资源文件id对应下载路径
	resourceIdToDownLoadPath: {},
	fileTypeToTypeEnum: {
		'image/png': 'png',
		'image/jpeg': 'jpg',
		'text/plain': 'txt',
		'video/mp4': 'mp4',
		'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
		'application/vnd.ms-excel': 'xls',
		'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
		'application/msword': 'doc',
		'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'ppt',
		'application/x-zip-compressed': 'zip',
		// 'text/plain': 'txt',
		'application/pdf': 'pdf',
	},
	fileTypeToIcoPath: {
		'xlsx': '/chat/ico_excel.svg',
		'xls': '/chat/ico_excel.svg',
		'doc': '/chat/ico_doc.svg',
		'docx': '/chat/ico_doc.svg',
		'ppt': '/chat/ico_ppt.svg',
		'txt': '/chat/ico_txt.svg',
		'pdf': '/chat/ico_pdf.svg',
		'svg': '/chat/ico_svg.svg',
		'mp3': '/chat/ico_mp3.svg',
		'zip': '/chat/ico_zip.svg',
	},
	customKanBanScreen:false
}

var store = new vm.Vuex.Store({
	state: copy(basestate),
	getters: {
		getPathList(state, getters) {
			if (state.pathList == undefined) {
				store.commit('getPathList')
				return []
			}
			return state.pathList
		},
		getResourcesByName(state) {
			return name => {
				if (state.nowSkinObject != undefined) {
					var str = './static/image/科技蓝/'
					
					return str + name
				}
				return
			}
		},
		getBackgroudImageStyle(state, getters) {
			return imgpath => {
				return {
					'background-image': 'url(' + getters.getResourcesByName(imgpath) + ')',
					'background-size': '100% 100%',
					'background-repeat': 'no-repeat'
				}
			}
		},
		getColorById(state) {
			//顔色值，通過id來查找
			return id => {
				if (state.nowSkinObject != undefined) {
					return state.nowSkinObject.colorMap[id]
				}
				return
			}
		},
		getColorStyleById(state, getters) {
			return colorId => {
				return {
					'color': getters.getColorById(colorId)
				}
			}
		},
		getBackgroudColorStyle(state, getters) {
			return colorId => {
				return {
					'background': getters.getColorById(colorId)
				}
			}
		},
		getClassName(state, getters) {
			//获取当前皮肤对应的class类名称
			return className => {
				if (state.nowSkinObject != undefined) {
					return state.nowSkinObject.skinTag + "-" + className
				}
				return className
			}
		},
		getDownLoadPath(state, getters) {
			return resourceIds => {
				var result = {}
				var needFindList = []
				for (var i = 0, len = resourceIds.length; i < len; i++) {
					var resourceId = resourceIds[i]
					var path = state.resourceIdToDownLoadPath[resourceId]
					if (path == undefined) {
						needFindList.push(resourceId)
					}
					result[resourceId] = path
				}
				if (needFindList.length > 0) {
					store.commit("getDownLoadPath", needFindList)
				}
				return result
			}
		}
	},
	mutations: {
		getPathList(state) {
			if (localStorage.getItem("token") || sessionStorage.getItem("token")) {
				resourcesApi.getPathList(res => {
					vm.Vue.set(state, 'pathList', res)
				})
			}
		},
		setCustomKanBan(state,res) {
			vm.Vue.set(state, 'customKanBanScreen', res)	
		},
		clear() {
			//清理缓存,resources不要提供清理缓存功能
		},
		setFilePath(state, path) {
			if (path == '通用') {
				path = '科技蓝'
			}
			var last = state.nowSkinObject
			vm.Vue.set(state, 'nowSkinObject', state.skinNameToSkinObject[path])
			//切换css
			if (last != undefined) {
				removeLink(last.skinPath)
			}
			if (state.nowSkinObject != undefined) {
				addLink(state.nowSkinObject.skinPath)
			}
		},
		getDownLoadPath(state, resourceIds) {
			resourcesApi.findResourcesByIds(resourceIds.join(','), respon => {
				for (var i = 0, len = respon.length; i < len; i++) {
					var item = respon[i]
					vm.Vue.set(state.resourceIdToDownLoadPath, item.pkid, DWSystemSetting.downloadUrl + item.urlPath + item.resourceName)
				}
			})
		},
		addSkin(state, skinObject) {
			vm.Vue.set(state.skinNameToSkinObject, skinObject.skinName, skinObject)
			if (state.nowSkinObject == undefined) {
				store.commit("setFilePath", skinObject.skinName)
			}
		}
	}
});

//对外提供
export default store

/**
 * 需要分页的内容,以数组存储全部,取的时候进行分页,
 * 刷新时获取指定页数据,然后合并,重复的数据以新的为准,
 * 可能会导致缺失遗漏,但是有清理缓存就可以了
 */
